





import { defineComponent } from '@vue/composition-api';
import { provideBoardCore } from '@/components/SettouMessageBoard/composables/useBoardCore';
import PcBoard from '@/components/SettouMessageBoard/components/PcBoard.vue';
import SpBoard from '@/components/SettouMessageBoard/components/SpBoard.vue';
import { useSpScreen } from '@/composables/useSpScreen';

export default defineComponent({
  components: {
    PcBoard,
    SpBoard,
  },
  setup() {
    provideBoardCore();

    const isSpScreen = useSpScreen();

    return {
      isSpScreen,
    };
  },
});
